export interface IAddress {
  fullname?: string;
  streetNumber?: string;
  street?: string;
  zipCode?: string;
  city?: string;
  cityCode?: string;
  country?: string;
  floor?: string;
  additionals?: string;
  gps_coords?: string;
}

export class Address implements IAddress {
  public fullname?: string;
  public streetNumber?: string;
  public street?: string;
  public zipCode?: string;
  public city?: string;
  public cityCode?: string;
  public country?: string;
  public floor?: string;
  public additionals?: string;
  public gps_coords?: string;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }

  public get toString(): string {
    return `${this.streetNumber || ''} ${this.street ? this.street + ', ' : ''}${this.zipCode || ''} ${this.city?.toUpperCase() || ''}`.trim();
  }
}

export class BillAddress extends Address {
  public billEmail?: string;

  constructor(data: any = {}) {
    super(data);
    this.billEmail = data.billEmail;
  }
}
